/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Information fulfilled by the doctor on him/her
 * @export
 * @interface DoctorInformation
 */
export interface DoctorInformation {
    /**
     * description of the diplomas of the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    diploma?: string;
    /**
     * presentation of the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    presentation?: string;
    /**
     * description of the fees charged by the doctor for the different consultations
     * @type {string}
     * @memberof DoctorInformation
     */
    fees?: string;
    /**
     * description of the means of payment accepted by the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    meansOfPayment?: string;
    /**
     * true if the teleconsultation can be possible, false otherwise
     * @type {boolean}
     * @memberof DoctorInformation
     */
    isTeleconsultationAvailable?: boolean;
    /**
     * true if the doctor is open to new patients, false otherwise
     * @type {boolean}
     * @memberof DoctorInformation
     */
    openToNewPatients?: boolean;
    /**
     * Complementary info describe by the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    complementaryInformation?: string;
    /**
     * Complementary info describe by the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    weekSchedule?: string;
    /**
     * description of the speciality of the doctor
     * @type {string}
     * @memberof DoctorInformation
     */
    speciality?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorInformation
     */
    generalMessage?: string;
}

/**
 * Check if a given object implements the DoctorInformation interface.
 */
export function instanceOfDoctorInformation(value: object): value is DoctorInformation {
    return true;
}

export function DoctorInformationFromJSON(json: any): DoctorInformation {
    return DoctorInformationFromJSONTyped(json, false);
}

export function DoctorInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'diploma': json['diploma'] == null ? undefined : json['diploma'],
        'presentation': json['presentation'] == null ? undefined : json['presentation'],
        'fees': json['fees'] == null ? undefined : json['fees'],
        'meansOfPayment': json['meansOfPayment'] == null ? undefined : json['meansOfPayment'],
        'isTeleconsultationAvailable': json['isTeleconsultationAvailable'] == null ? undefined : json['isTeleconsultationAvailable'],
        'openToNewPatients': json['openToNewPatients'] == null ? undefined : json['openToNewPatients'],
        'complementaryInformation': json['complementaryInformation'] == null ? undefined : json['complementaryInformation'],
        'weekSchedule': json['weekSchedule'] == null ? undefined : json['weekSchedule'],
        'speciality': json['speciality'] == null ? undefined : json['speciality'],
        'generalMessage': json['generalMessage'] == null ? undefined : json['generalMessage'],
    };
}

export function DoctorInformationToJSON(json: any): DoctorInformation {
    return DoctorInformationToJSONTyped(json, false);
}

export function DoctorInformationToJSONTyped(value?: DoctorInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diploma': value['diploma'],
        'presentation': value['presentation'],
        'fees': value['fees'],
        'meansOfPayment': value['meansOfPayment'],
        'isTeleconsultationAvailable': value['isTeleconsultationAvailable'],
        'openToNewPatients': value['openToNewPatients'],
        'complementaryInformation': value['complementaryInformation'],
        'weekSchedule': value['weekSchedule'],
        'speciality': value['speciality'],
        'generalMessage': value['generalMessage'],
    };
}

